import { Layout } from '../components/Layout';
import { SMSOTPSetupForm } from '../components/SMSOTPSetupForm';

export const SMSOTPSetup = () => {
  return (
    <Layout title="SMS OTP Setup">
      <SMSOTPSetupForm />
    </Layout>
  );
};
